import { updateSort, updateSortDirection } from '@store/redux/features/filter';
import { IFilter } from '@pages/Products/Products';

export const handleSortClick = (
  searchText: string,
  headerSort: string,
  filter: IFilter,
  dispatch: any,
  startSearch: (
    input?: string,
    sort?: string,
    direction?: 'ASC' | 'DESC' | undefined,
  ) => void,
) => {
  if (filter?.sort !== headerSort) {
    startSearch(searchText, headerSort, 'DESC');
    dispatch(updateSort(headerSort));
    dispatch(updateSortDirection('DESC'));
    return;
  }
  const direction = filter?.direction === 'DESC' ? 'ASC' : undefined;
  const headerSorting = filter?.direction === 'DESC' ? headerSort : undefined;
  startSearch(searchText, headerSort, direction);
  dispatch(updateSortDirection(direction));
  dispatch(updateSort(headerSorting));
};
